import React, { useEffect, useState } from "react";
import { TYPE_GET_DATE } from "../../../../helper/const";
import { getDateChangeTime } from "../../../../helper/helper";
import FilterTime from "../../../components/FilterTime";
import DashboardCompare from "../../../Natcom/components/DashboardCompare";
import { useSelector } from "react-redux";
import { selectorDataMytel } from "../../../../redux/selector";
import { useMemo } from "react";
import _ from "lodash";
import { Tabs } from "antd";

export default function Compare({ tabActive, handleGetData }) {
  const [startDate, setStartDate] = useState(
    getDateChangeTime(TYPE_GET_DATE.oneDayAgo)
  );
  const [endDate, setEndDate] = useState(getDateChangeTime(TYPE_GET_DATE.now));
  const { result = {} } = useSelector(selectorDataMytel)?.revenue;

  const { dataHourMap = [] } = result;
  console.log('dataHourMap: ', dataHourMap);
  
  const [tabCompare, setTabCompare] = useState("total_num_charge");
  const onChangeTabs = (key) => {
    setTabCompare(key);
  };



  const itemsTab = [
    {
      key: "total_num_charge",
      label: "Charge",
    },
    {
      key: "total_num_charge_success",
      label: "Charge Success",
    },
    {
      key: "revenue_register",
      label: "Register Revenue",
    },
    {
      key: "revenue_renew",
      label: "Renew Revenue",
    },
    {
      key: "total_revenue",
      label: "Total Revenue",
    }
  ];
  useEffect(() => {
    if (tabActive !== "3") {
      return;
    }
    handleGetData(startDate, endDate);
  }, [startDate, endDate, tabActive]);

  const dataCharts = useMemo(() => {
    if (_.isEmpty(result)) {
      return [];
    }
    const { dataHourMap } = result;
    const handleGetData = (data, category, dataItems) => {
    const defineData = Array.from({ length: 24 }, (_, i) => ({
      hour: `${i.toString().padStart(2, "0")}:00`, 
      total_hour: 0,
      category
    }));

      if (_.isEmpty(data)) {
        return defineData;
      }

      for (let i = 0; i < defineData.length; i++) {
        const datas = data.find(
          (item) => `${item.hour}:00` === defineData[i].hour
        );
        defineData[i].total_hour = +datas?.[dataItems] || 0;
      }

      return defineData;
    };
    const dataStart =
      handleGetData(dataHourMap[startDate], startDate, tabCompare) || [];
    const dataEnd =
      handleGetData(dataHourMap[endDate], endDate, tabCompare) || [];

    return [...dataStart, ...dataEnd];
  }, [result, startDate, endDate, tabCompare]);



  return (
    <>
      <div
        className="position-relative d-flex justify-right mb-2"
        style={{ justifyContent: "right" }}
      >
        <FilterTime
          startDate={startDate}
          setStartDate={setStartDate}
          endDate={endDate}
          setEndDate={setEndDate}
        />
      </div>
      <div className="container-dashboard">
        <Tabs defaultActiveKey="total_num_charge" items={itemsTab} onChange={onChangeTabs} />
      </div>
      <div>
        <DashboardCompare
          dataChart={dataCharts}
          startDate={startDate}
          endDate={endDate}
        />
      </div>
    </>
  );
}
